var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imofalform3itemsFormHeader puiformheader"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('pui-field',{attrs:{"label":_vm.$t('header.imofalform3items.imofalform3id'),"value":_vm.getImofalform3idValue}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }